import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
} from "@mui/material";
import Modal from "@/components/Modal";
import tokens from "@/theme/tokens";

const InviteErrorModal = ({ isOpen, close, t, errorEmails = [] }) => (
  <Modal
    isOpen={isOpen}
    handleClose={close}
    title={t("errorSendingInvites")}
    fullWidth
    maxWidth="md"
  >
    {/* The dialog sizes itself; the table scrolls if it cannot fit. */}
    <Box sx={{ my: 2, overflowX: "auto" }}>
      <Table sx={{ minWidth: 480 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontSize: tokens.fontSize.inviteErrorTableCell }}>{t("Email")}</TableCell>
            <TableCell sx={{ fontSize: tokens.fontSize.inviteErrorTableCell }} align="right">
              {t("errorMessage")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {errorEmails.map((row) => (
            <TableRow
              key={row.email_address}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.email_address}
              </TableCell>
              <TableCell align="right">{t(row.error)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  </Modal>
);

export default InviteErrorModal;
